'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.displayError = function (reason, retainErrors) {
	return mmWidgets.each(this, function () {
		const section = this;
		if (!retainErrors) {
			section.find('[data-mm-role~=error]').addClass('hidden');
		}
		if (reason) {
			section.find('[data-mm-role~=error][data-mm-reason~="' + reason.replace(/"/g, '') + '"]').removeClass('hidden');
			if (section.find('[data-mm-role~=error]:not(.hidden)').length === 0) {
				section.find('[data-mm-role~=error]:not([data-mm-reason])').removeClass('hidden');
			}
		}
	});

};
